import {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";
import {FullGameFetchHandler} from "../../../core/handlers/full-game.fetch-handler";
import {FullGameResponseDomainService} from "../../../domain/full-game/services/full-game-response.domain-service";
import {CompetitorPlayersStatsModuleState} from "../models/competitor-players-stats-module.state";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";

export class CompetitorPlayersStatsModuleFetchHandler extends FullGameFetchHandler {
  controller: CompetitorPlayersStatsModuleController;
  state: CompetitorPlayersStatsModuleState;

  static injectables = [FullGameResponseDomainService];

  onLoaded() {
    super.onLoaded();

    this.state.selectedAthleteId = this.controller.props.selectedAthleteId;
    this.state.firstSelectedAthleteId = this.controller.props.selectedAthleteId;
    this.state.competitorId = this.controller.props.competitorId;
  }

  async action() {

    await this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.athleteLineupFetch);
    await this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.statsDisplayHandler, {
      gameId: this.controller.props.gameId,
      status: this.state.gameStatus,
      sportTypeId: this.state.selectedPlayer?.sport?.id,
      athleteId: this.state.selectedAthleteId,
      source: this.controller.props.source,
      isHeatmap: !!this.state.selectedPlayer?.heatMap,
      isFirst: this.state.isFirstSelectedAthlete
    })

    if(this.state.isShallowShotMap){
      this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onShotSelected, {
        shot: this.state.selectedPlayer.selectedShotKey === null ? this.state.selectedPlayer.shots?.first(): null
      });
    }
    this.state.activeTabIndex = this.state.tabs?.first()?.index;
  }
}
